var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMuted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 5.2929L15 11.2929M15 5.2929L21 11.2929M8.63432 1.65858L5.46863 4.82427C5.29568 4.99722 5.2092 5.08369 5.10828 5.14554C5.01881 5.20036 4.92127 5.24077 4.81923 5.26527C4.70414 5.2929 4.58185 5.2929 4.33726 5.2929H2.6C2.03995 5.2929 1.75992 5.2929 1.54601 5.40189C1.35785 5.49776 1.20487 5.65074 1.10899 5.83891C1 6.05282 1 6.33284 1 6.8929V9.6929C1 10.2529 1 10.533 1.10899 10.7469C1.20487 10.935 1.35785 11.088 1.54601 11.1839C1.75992 11.2929 2.03995 11.2929 2.6 11.2929H4.33726C4.58185 11.2929 4.70414 11.2929 4.81923 11.3205C4.92127 11.345 5.01881 11.3854 5.10828 11.4403C5.2092 11.5021 5.29568 11.5886 5.46863 11.7615L8.63431 14.9272C9.06269 15.3556 9.27688 15.5698 9.46077 15.5842C9.62033 15.5968 9.77626 15.5322 9.8802 15.4105C10 15.2702 10 14.9673 10 14.3615V2.22427C10 1.61845 10 1.31554 9.8802 1.17528C9.77626 1.05357 9.62033 0.988986 9.46077 1.00154C9.27688 1.01602 9.06269 1.2302 8.63432 1.65858Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuted);
export default __webpack_public_path__ + "static/media/muted.952fd5ca8e3d935a7a0298be8a81b30e.svg";
export { ForwardRef as ReactComponent };